import React from 'react'
import { secondsToHoursMinutes } from 'src/utils'
import { RIDER_PORTAL_UI_MESSAGES } from 'src/constants/rider-portal'

interface IRideDurationProps {
  duration: number
}

const RideDuration = ({ duration }: IRideDurationProps) => {
  const {
    trips: { details }
  } = RIDER_PORTAL_UI_MESSAGES
  return (
    <div>
      <h4 className='font-black3 font-medium rp-mb8 rp-my0 text-center text-md'>{details.estimatedTripDuration}</h4>
      <p className='font-grey8 mt0 rp-mb0 text-center text-md'>{secondsToHoursMinutes(duration)}</p>
    </div>
  )
}

export default RideDuration



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/trips/details/RideDuration.tsx